module.exports = __webpack_public_path__ + "media/file_icons/mp4-1ad9da93.svg";